import { I18nContext } from 'contexts/I18n/I18nProvider'
import { RTFSettingsTab, SIDEBAR_ITEMS_GROUPS_MAP } from 'modules/operational/rtf/config/sidebar'
import React, { useContext } from 'react'
import './index.scss'
import Items from './Items'

type SidebarProps = {
  tab: RTFSettingsTab
  setTab: React.Dispatch<React.SetStateAction<RTFSettingsTab>>
}

const i18nGroupsMap = {
  settings: 'rtf.group.settings',
  history: 'rtf.group.history',
}

export default function Sidebar({ tab, setTab }: SidebarProps) {
  const t = useContext(I18nContext)
  const groupItems = SIDEBAR_ITEMS_GROUPS_MAP
  const groups = Object.keys(groupItems) as Array<keyof typeof SIDEBAR_ITEMS_GROUPS_MAP>// ["settings", "history"]

  return (
    <div className="rtf-side-menu-container">
      <div>
        {groups.map((groupName) => (
          <div className="columns flex-wrap" key={groupName}>
            <div className={'column is-12 is-relative rtf-side-menu-is-group-name'}>{t(i18nGroupsMap[groupName])}</div>
            <Items items={groupItems[groupName]} tab={tab} setTab={setTab} />
          </div>
        ))}
      </div>
    </div>
  );
}
